import React from "react";
import "../streamcss/invitation.css";



const InvitationModal = ({ title, message, onAllow, onDeny }) => {

 

   
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <span className="modal-title">{title}</span>
        </div>
        <div className="modal-body">
          <p className="modal-message">{"Givent wants to send an invitation to all meeting participants"}</p>
        </div>
        <div className="modal-footer">
          <button className="modal-button allow-button" onClick={onAllow}>
            Allow
          </button>
          <button className="modal-button deny-button" onClick={onDeny}>
            Don't allow
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvitationModal;
